import { EntityApi } from "../../services/ApiPlatform";

export abstract class GestureApi extends EntityApi {
    protected static GET_COLLECTION = "/api/gestures";

    protected static POST_COLLECTION = "/api/gestures";

    protected static GET_ITEM = "/api/gestures/{id}";

    protected static PUT_ITEM = "/api/gestures/{id}";

    protected static PATCH_ITEM = "/api/gestures/{id}";

    protected static DELETE_ITEM = "/api/gestures/{id}";
}
